<template>
    <vue-select v-model="itemType" :reduce="t => t.type" label="name" :clearable="false" :options="options" :append-to-body="appendToBody">
        <template #open-indicator>
            <i class="ml-auto fas fa-caret-down"></i>
        </template>
        <template v-slot:selected-option="option">
            <i class="fa-fw float-left pt-1 fas mr-1" :class="option.glyph"/>
            <div>{{ option.name|tr }}</div>
        </template>
        <template v-slot:option="option">
            <div class="menu-option">
                <i class="fa-fw float-left fas pt-1 mr-1" :class="option.glyph"/>
                <div>{{ option.name|tr }}</div>
            </div>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    name: `select-cms-item-type`,
    components: {VueSelect},
    props: {
        value: {type: String, required: true},
        itemTypes: {type: Array},
        appendToBody: {type: Boolean},
        showInherit: {type: Boolean},
        showUniversal: {type: Boolean}
    },
    data() {
        return {
        }
    },
    computed: {
        itemType: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        },
        options() {
            let options = clone(this.itemTypes);
            if (this.showUniversal) {
                options.push({
                    type: 'universal-search',
                    name: `Universal|Universel`,
                    glyph: `fas fa-search`
                });
            }
            if (this.showInherit) {
                options.push({
                    type: 'inherit',
                    name: `Default (inherit from page)|Défaut (hériter de la page)`,
                    glyph: `fas fa-file-text`
                });
            }
            return options;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
